import groupService from '../../services/group-service';
import sensorService from '../../services/sensor-service';
import Logger from '../../toolkit/logger/Logger';
import DialogComponent, { DialogProps } from '../widgets/dialog/DialogComponent';

export interface SaveDialogProps extends DialogProps {
  data: any[]
}

export default class SaveDialog extends DialogComponent<SaveDialogProps> {

  state = {
    finished: 0
  }

  render() {
    const { data } = this.props;
    const { finished } = this.state;
    return (
      <>
        در حال ذخیره سازی {finished + 1} از {data.length} مورد
      </>
    );
  }

  componentDidMount = () => {
    const { data } = this.props;
    const request = [];
    for (const item of data) {
      request.push(this.requestWrapper.bind(this, item));
    }
    Promise.all(request.map(r => r()));
  }

  requestWrapper = async (item: any) => {
    Logger.info('FloatItem::SaveDialog::start ', this.state.finished);
    const { data } = this.props;
    const { finished } = this.state;
    try {
      const { id, type, top, left } = item;
      if (type === 'group') {
        await groupService.updatePicturePoint(id, { top, left });
      }
      else {
        await sensorService.updatePicturePoint(id, { top, left });
      }
      Logger.info('FloatItem::SaveDialog::result ', finished);
      this.setState({ finished: this.state.finished + 1 }, () => {
        if(this.state.finished === data.length) {
          setTimeout(() => {
            this.close();
          }, 500);
        }
      });
    }
    catch (e) {
      console.error(e);
      this.close();
      alert('خطا در ذخیره اطلاعات');
    }
  }

}
